export default __webpack_public_path__ + "static/media/IMG_9961.db54805e.jpg";